__turbopack_context__.v({
  "caret": "window-of-opportunity-module__vfJa-a__caret",
  "headline": "window-of-opportunity-module__vfJa-a__headline",
  "line": "window-of-opportunity-module__vfJa-a__line",
  "out": "window-of-opportunity-module__vfJa-a__out",
  "page": "window-of-opportunity-module__vfJa-a__page",
  "say": "window-of-opportunity-module__vfJa-a__say",
  "stage": "window-of-opportunity-module__vfJa-a__stage",
  "warn": "window-of-opportunity-module__vfJa-a__warn",
});
